import React, { Component } from 'react'
import config from '../config.json'
import addItemIdToFilter from "../functions/addItemToFilter";
import OverviewTitle from './OverviewTitle';
import BackToOverview from './BackToOverview';
import queryString from 'query-string'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails';
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import Scroll from 'react-scroll'
import Translation from '../General/Translation';
import FilterResultsMovieArthouseItem from './FilterResultsMovieArthouseItem';
import getMovieLink from '../functions/getMovieLink';
import hasToggleMovieDatesOnMobile from '../hoc/hasToggleMovieDatesOnMobile';
import { trackMoviePerformanceOpen } from '../tracking';

const scroller = Scroll.scroller;
class FilterResultsMovieArthouse extends Component {
    constructor(props) {
        super(props)

        this.state = { 
            titleFilter: {}
        }
    }

    getMoviesTitleList() {
        const { routesData } = this.props
        let filterTitles = {}

        if(routesData.movies.items) {
            Object.keys(routesData.movies.items).map(movieId => {
                const { uri_path } = routesData.movies.items[movieId]
                if( uri_path ) {
                    filterTitles = addItemIdToFilter(filterTitles, uri_path, movieId)
                }
            })
        }

        return filterTitles
    }

    getMovieIds() {
        const { match, movies } = this.props
        const { titleFilter } = this.state
        let movieIds = []

        if(match.params.movieParam && titleFilter.hasOwnProperty(match.params.movieParam)) {
            const ids = titleFilter[match.params.movieParam]

            ids.map(id => {
                if(movies.order.includes(id)) {
                    movieIds.push(id)
                }
            })
        }

        return 0 == movieIds.length ? false : movieIds
    }

    movieHasPerformance(queryStringValues) {
        const {movies} = this.props
        const movieIds = this.getMovieIds()
        let relevantPerformances = []
        
        if(movieIds) {
            movieIds.map(movieId => {
                const movie = movies.items[movieId]
                
                if(movie) {
                    const {performances} = movie
                    
                    const relevantPerformance = _.find(performances, (performance => {
                        if(queryStringValues && queryStringValues.performance_id) {
                            return performance.id === queryStringValues.performance_id
                        }
                    }))
                    
                    if(relevantPerformance) {
                        const performanceData = {
                            performance: relevantPerformance,
                            movie: movie
                        }
                        relevantPerformances.push(performanceData)
                    }
                }
            })
        }

        return relevantPerformances
    }

    componentDidUpdate(prevProps) {
        const queryStringValues = queryString.parse(this.props.location.search)
        const relevantPerformancesData = this.movieHasPerformance(queryStringValues)
        if(!prevProps.activePerformance && queryStringValues && queryStringValues.performance_id) {
            if(relevantPerformancesData && relevantPerformancesData.length !== 0) {
                const {performance,  movie} = relevantPerformancesData[0]
                const {id, timeUtc, deeplinkURL, cinema} = performance
                const {title, titleDisplay} = movie
                this.props.onOpenPerformancePage({
                    id: id,
                    timeUtc: timeUtc,
                    cinema: cinema,
                    url: deeplinkURL,
                    movieId: movie.pk,
                    movieTitle: titleDisplay ? titleDisplay : title
                })

                const performancePageElemCompeso = document.getElementById('compeso-iframe')
                const performancePageElemDiesel = document.getElementById('diesel-iframe')

                if(performancePageElemCompeso || performancePageElemDiesel) {
                    setTimeout(() => {
                        scroller.scrollTo(movie.pk + ' performance-iframe', {
                            offset: -200,
                            isDynamic: true,
                            smooth: true
                        })
                    }, 500)
                }
            }
        }
    }

    componentDidMount() {
        this.setState({
            titleFilter: this.getMoviesTitleList()
        })
    }
    
    render() {
        const { 
            activePerformance, 
            activeDetailsItem,
            movies, 
            moviesRoutesData,
            theme, 
            match, 
            translation, 
            routesData, 
            overviewSubtitle,
            toggleMovieDatesOnMobileView,
            currentDateActive,
            performancePageOpen, 
            displaySidebarRight, 
            displaySidebarRightSecond, 
            onClosePerformancePage, 
            onOpenPerformancePage, 
            onOpenDetailsFirstSidebar,
            onCloseDetailsFirstSidebar
        } = this.props

        const movieIds = this.getMovieIds()

        if(!movieIds) {
            return (
                <div className={"overview overview-view-list"}>
                    <OverviewTitle singleMovie={false} notFound={true} translation={translation} overviewSubtitle={overviewSubtitle}/>
                    <BackToOverview translation={translation} pathname={match.params.overviewParam}/>
                </div>
            )
        }

        return (
            <div className={"overview overview-view-list arthouse-movie"}>
                {0 === movieIds.length ? (
                    <h3 className="no-movie title-xlarge-theatre">
                        <Translation id="ThereCurrentlyNoFilmsTypes" trans={translation} />
                    </h3>
                ) : (
                    movieIds.map((itemId, index) => {
                        return <FilterResultsMovieArthouseItem 
                            key={index}
                            itemData={movies.items[itemId]}
                            itemsData={movies.items}
                            itemLink={getMovieLink(itemId, moviesRoutesData, translation)}
                            theme={theme}
                            moviesRoutesData={moviesRoutesData}
                            translation={translation}
                            queryStringValues={{}}
                            onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, 'eventOrigins.listitem')}
                            currentDateActive={currentDateActive}
                            toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                            activePerformance={activePerformance}
                            displaySidebarRightSecond={displaySidebarRightSecond} 
                            onClosePerformancePage={onClosePerformancePage} 
                            onOpenPerformancePage={onOpenPerformancePage} 
                            onOpenDetails={onOpenDetailsFirstSidebar}
                            onCloseDetails={onCloseDetailsFirstSidebar}
                            performancePageOpen={performancePageOpen} 
                            displaySidebarRight={displaySidebarRight} 
                            routesData={routesData}
                            activeDetailsItem={activeDetailsItem}
                        />
                    })
                )}
            </div>
        )
    }
}


export default hasSlidebarRightAndSecond({breakpoint:  config.breakpoints.slidebarRight})(hasToggleMovieDatesOnMobile(hasOpenInformationAndDetails(FilterResultsMovieArthouse)))